import { render, staticRenderFns } from "./MembersRanking.vue?vue&type=template&id=f6808610&scoped=true&lang=pug&"
import script from "./MembersRanking.vue?vue&type=script&lang=js&"
export * from "./MembersRanking.vue?vue&type=script&lang=js&"
import style0 from "./MembersRanking.vue?vue&type=style&index=0&id=f6808610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6808610",
  null
  
)

/* custom blocks */
import block0 from "./MembersRanking.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VLayout,VSpacer,VTab,VTabs})
